import React from 'react';
import Icon from '../../Icon/components/Icon';

const ChevronIcon = (props) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      {...props}
    >
      <polyline points="6 9 12 15 18 9" />
    </Icon>
  );
};

export default ChevronIcon;
